import * as React from 'react';

import {Date} from 'shells/entity/entity-display-values/date';

import styles from './cell.module.css';

type Props = {
    value: string;
};

export function CellDate(props: Props) {
    return (
        <div className={styles['cell-content']}>
            {/* @ts-expect-error */}
            <Date value={props.value} />
        </div>
    );
}
